import React from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import styles from './styles';

export interface ILimitedTooltipListItem {
  key: string;
  label: string;
  onClick?: () => void;
}

interface ILimitedTooltipList {
  items: Array<ILimitedTooltipListItem>;
  isCenterAligned?: boolean;
  showAllItemsInTooltip?: boolean;
  visibleCount?: number;
}

const defaultProps = {
  isCenterAligned: false,
  showAllItemsInTooltip: false,
  visibleCount: 2,
};

const LimitedTooltipList = ({
  items,
  isCenterAligned = defaultProps.isCenterAligned,
  showAllItemsInTooltip = defaultProps.showAllItemsInTooltip,
  visibleCount = defaultProps.visibleCount,
}: ILimitedTooltipList) => {
  const visibleItems = items.slice(0, visibleCount);
  const hiddenItems = items.slice(visibleCount);
  const tooltipItems = showAllItemsInTooltip ? items : hiddenItems;
  const tooltipTitle = tooltipItems
    .map(({ label }) =>
      label)
    .join(', ');

  const content = (
    <Box component="span" sx={styles.container(isCenterAligned)}>
      {visibleItems.map(({ key, label, onClick }, index) => {
        const showSeparator = index < visibleItems.length - 1 || hiddenItems.length > 0;

        return (
          <Typography
            key={key}
            component={onClick ? 'a' : 'span'}
            onClick={onClick}
            sx={onClick ? styles.link : styles.text}
          >
            {label}
            {showSeparator ? ',' : ''}
          </Typography>
        );
      })}
      {!!hiddenItems.length && (
        <Typography component="span" sx={styles.ellipsis}>
          ...
        </Typography>
      )}
    </Box>
  );

  if (!hiddenItems.length) {
    return content;
  }

  return (
    <Tooltip arrow placement="top" title={tooltipTitle}>
      {content}
    </Tooltip>
  );
};

export default LimitedTooltipList;
